var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center"},[_vm._v(" Bitte über das  "),_c('a',{attrs:{"href":"https://portal.comline.app/"}},[_vm._v("ComLine-Portal")]),_vm._v("  anmelden! ")])
}]

export { render, staticRenderFns }